import { render, staticRenderFns } from "./aForm.vue?vue&type=template&id=70c67758"
import script from "./aForm.vue?vue&type=script&lang=js"
export * from "./aForm.vue?vue&type=script&lang=js"
import style0 from "./aForm.vue?vue&type=style&index=0&id=70c67758&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports